"use client";

import Link from "next/link";

const Terms = () => {
    return (
        <main className="max-w-3xl mx-auto px-6 py-20">
            <header className="mb-12">
                <h1 className="text-5xl font-extrabold text-gray-900 mb-2">
                    Terms of Service
                </h1>
                <p className="text-sm text-gray-500">
                    Last updated: June 30, 2025
                </p>
            </header>

            <section className="space-y-10 text-base text-gray-800 leading-relaxed">
                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        1. Acceptance of Terms
                    </h2>
                    <p>
                        By accessing or using <strong>MyBlog Times</strong>, you
                        agree to be bound by these Terms of Service and all
                        applicable laws. If you do not agree, please do not use
                        the site.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        2. Content Use
                    </h2>
                    <p>
                        All content is provided for informational purposes only.
                        You may not copy, reproduce, or republish content
                        without written permission unless otherwise stated.
                        Brief excerpts with proper attribution are permitted for
                        sharing.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        3. Disclaimer
                    </h2>
                    <p>
                        The content on this site is offered "as is" without
                        warranties of any kind. We are not responsible for
                        errors, omissions, or outcomes resulting from the use of
                        this website.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        4. User Behavior
                    </h2>
                    <p>
                        You agree not to use this site for any unlawful purpose
                        or to disrupt the normal operation of the website.
                        Spamming, scraping, or any form of automated access is
                        prohibited.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        5. External Links
                    </h2>
                    <p>
                        This site may contain links to third-party sites. We are
                        not responsible for their content, policies, or
                        practices. Please review their terms separately.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        6. Privacy
                    </h2>
                    <p>
                        Please review our{" "}
                        <Link
                            href="/privacy-policy"
                            className="text-blue-600 hover:underline font-medium"
                        >
                            Privacy Policy
                        </Link>{" "}
                        to understand how we collect and use your information.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        7. Changes
                    </h2>
                    <p>
                        We may update these Terms occasionally. Continued use of
                        the site after updates constitutes your agreement to the
                        revised Terms.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        8. Contact
                    </h2>
                    <p>
                        If you have any questions about these Terms, you can{" "}
                        <Link
                            href="/contact"
                            className="text-blue-600 hover:underline font-medium"
                        >
                            contact us
                        </Link>
                        .
                    </p>
                </div>
            </section>
        </main>
    );
};
export default Terms;
